<template>
	<b-modal
		:hide-footer="true"
		:title="$t('Renomear')"
		centered
		id="renomear-pasta"
	>
		<div class="row px-3">
			<div class="col-12 alert alert-danger" v-if="error">
				{{ error }}
			</div>
			<div class="row col-12 px-3 d-flex justify-content-center" v-if="loading">
				<load mode="table" />
				<h5 class="my-3">
					Renomeando de <b>{{ nome }}</b> para <b>{{ newname }}</b>
				</h5>
			</div>
			<form v-else @submit.prevent="submit" ref="addItem" class="col-12 px-0">
				<div class="row">
					<form-input label="Digite o novo nome" v-model="newname" />
				</div>
				<div class="row px-2 d-flex justify-content-end">
					<button class="btn btn-primary btn-sm" @click="submit">Salvar</button>
				</div>
			</form>
		</div>
	</b-modal>
</template>
<script>
export default {
	props: ["path", "item"],
	data() {
		return {
			newname: "",
			nome: "",
			error: "",
			loading: false,
		};
	},
	watch: {
		item(n, o) {
			this.nome = this.item.nome;
			this.newname = this.item.nome;
		},
	},
	methods: {
		submit() {
			this.loading = true;
			this.error = null;
			if (this.newname != this.nome) {
				axios
					.post(`api/dashboard/documento/rename`, {
						newname: this.newname,
						item: this.item,
						caminho: this.path,
					})
					.then((response) => {
						if (response.data.error) {
							this.error = response.data.error;
						} else {
							this.$emit("reload", this.path);
							this.$bvModal.hide("renomear-pasta");
							this.error = null;
							this.nome = "";
							this.newname = "";
						}
					})
					.finally(() => {
						this.loading = false;
					});
			} else {
				this.error = "Os novo nome é igual ao antigo.";
			}
		},
	},
};
</script>
